import { all, fork } from "redux-saga/effects";
import { allowedChangesSaga } from "./sagas/allowedChangesSaga";
import { applicationSaga } from "./sagas/applicationSaga";
import { counterSaga } from "./sagas/counterSaga";
import { stepperSaga } from "./sagas/stepperSaga";

export function* rootSaga() {
    yield all([fork(counterSaga), fork(stepperSaga), fork(applicationSaga), fork(allowedChangesSaga)]);
}
